import {
  AttendanceStatus,
  StationeryItemStatus,
  StationeryStatus,
  StepStatus,
} from "../../enum/common";

export const getAttendanceStatus = (status: AttendanceStatus) => {
  switch (status) {
    case AttendanceStatus.ON_TIME:
      return {
        label: "Đi đúng giờ",
        color: "success",
      };
    case AttendanceStatus.LATE:
      return {
        label: "Đi trễ",
        color: "error",
      };
    case AttendanceStatus.EARLY:
      return {
        label: "Về sớm",
        color: "orange",
      };
    case AttendanceStatus.ABSENT:
      return {
        label: "Chưa chấm công",
        color: "blue",
      };
    default:
      return {
        label: "Chưa xác định",
        color: "default",
      };
  }
};

export const getStatusTag = (status: StepStatus) => {
  switch (status) {
    case StepStatus.APPROVED:
      return {
        label: "Đã duyệt",
        color: "green",
        bgColor: "#e6f4ea",
      };
    case StepStatus.REJECTED:
      return {
        label: "Từ chối",
        color: "red",
        bgColor: "#fce8e6",
      };
    case StepStatus.DIRECTOR_PENDING:
      return {
        label: "Chờ giám đốc duyệt",
        color: "orange",
        bgColor: "orange",
      };
    case StepStatus.HR_PENDING:
      return {
        label: "Chờ nhân sự duyệt",
        color: "orange",
        bgColor: "orange",
      };
    case StepStatus.MANAGER_PENDING:
      return {
        label: "Chờ quản lý duyệt",
        color: "orange",
        bgColor: "orange",
      };
    default:
      return {
        label: "Chờ duyệt",
        color: "orange",
        bgColor: "#fef3e1",
      };
  }
};

export const getTypeTag = (type: string) => {
  switch (type) {
    case "PLAN":
      return {
        label: "Nghỉ có kế hoạch",
        color: "blue",
      };
    case "SUDDENTY":
      return {
        label: "Nghỉ đột xuất",
        color: "volcano",
      };
    case "EARLY":
      return {
        label: "Về sớm",
        color: "gold",
      };
    default:
      return {
        label: "Tất cả",
        color: "default",
      };
  }
};
export const getReasonTag = (reason: string) => {
  switch (reason) {
    case "SICK":
      return {
        label: "Ốm đau",
        color: "red",
      };
    case "CONDOLENCE":
      return {
        label: "Việc hiếu/hỉ",
        color: "purple",
      };
    case "OTHER":
      return {
        label: "khác",
        color: "default",
      };
    default:
      return {
        label: reason,
        color: "default",
      };
  }
};

export const getStationeryTag = (status: StationeryStatus) => {
  switch (status) {
    case StationeryStatus.OPEN:
      return {
        label: "Mở",
        color: "green",
      };
    case StationeryStatus.CLOSED:
      return { label: "Đóng", color: "red" };
    case StationeryStatus.UPCOMING:
      return { label: "Sắp diễn ra", color: "blue" };
    default:
      return { label: status, color: "default" };
  }
};
export const getStationeryItemTag = (status: StationeryItemStatus) => {
  switch (status) {
    case StationeryItemStatus.IS_BUYED:
      return {
        label: "Đã mua",
        color: "green",
      };
    case StationeryItemStatus.IS_BUYING:
      return { label: "Đang mua", color: "yellow" };
    case StationeryItemStatus.IS_NOT_BUYED:
      return { label: "Không mua", color: "red" };
    case StationeryItemStatus.IS_NOT_BUY_YET:
      return { label: "Chưa mua", color: "blue" };
    case StationeryItemStatus.IS_RETURNED:
      return { label: "Bị trả lại", color: "orange" };
    default:
      return { label: status, color: "default" };
  }
};
